import React from 'react'
import { useTranslation } from 'react-i18next';

import {
  TableHead,
  TableRow,
  TableCell,
  withStyles
} from '@material-ui/core'

import { CommonFonts } from '@/theme'

const TableHeader = () => {
  const { t } = useTranslation()

  const headCells = [
    {
      id: 'date_time',
      label: t('expenses.date_time'),
      width: '15%',
    },
    {
      id: 'payee',
      label: t('expenses.payee'),
      width: '15%',
    },
    {
      id: 'status',
      label: t('expenses.status'),
      width: '15%',
    },
    {
      id: 'amount',
      label: t('expenses.amount'),
      width: '15%',
    },
    {
      id: 'payment_status',
      label: t('expenses.payment_status'),
      width: '15%',
    },
    {
      id: 'files',
      label: t('expenses.files'),
      width: '15%',
    },
    {
      id: 'empty',
      label: '',
      width: '10%',
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            style={{
              width: headCell.width,
              borderBottom: 'none'
            }}
          >
            {headCell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const StyledTableCell = withStyles(() => ({
  root: {
    borderBottom: 'none',
    ...CommonFonts.darkFont14,
    fontWeight: 'normal'
  },
  head: {
    backgroundColor: '#F3F5F7',
  },
  body: {
    ...CommonFonts.darkFont14
  },
}))(TableCell);


export default TableHeader